import React from "react";
import { Helmet } from 'react-helmet';

class GottfriedLandingPage extends React.Component {
    render() {

        const styleContent = `
            .lom-box-grau {
                background-color: #F8F9FA;
                padding: 20px 25px;
                margin-bottom: 50px;
            }

            .lom-box-h1 {
                background: #0E0E0E;
                padding: 20px 25px 10px 25px;
                color: #fff;
                margin-bottom: 30px;
            }

            .lom-box-kategorie {
                background: #fff;
                text-align: center;
                box-shadow: 0 5px 15px rgba(0, 0, 0, .08);
                padding: 15px;
            }

            .fake-h2 {
                font-size: 1.375rem;
                line-height: 1.3;
                font-weight: 600;
            }

            .lom-faq-details {
                background: #F8F9FA;
                margin-bottom: 1.5rem;
            }

            .lom-fag-antwort {
                padding: 1rem 1rem 1px 1rem;
            }


            .lom-faq-summary {
                padding: 1rem;
                background: #0E0E0E;
                color: #fff;
                cursor: pointer;
            }

            .lom-button-kategorie {
                color: #fff;
                background-color: #000;
                curser: pointer;
                display: inline-block;
                font-weight: 400;
                text-align: center;
                white-space: nowrap;
                vertical-align: middle;
                user-select: none;
                border: 1px solid transparent;
                padding: 0.375rem 0.75rem;
                font-size: 1rem;
                line-height: 1.5;
                transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
                width: 100%;
                text-decoration: none;
                text-transform: uppercase;
            }

            .lom-button-kategorie:hover {
                color: #d8dce4;
            }

            .lom-button-ausrichtung {
                vertical-align: middle;
                text-align: right;
            }

            .lom-zweispaltig {
                display: grid;
                grid-template-columns: 1fr 1fr;
                grid-template-rows: 1fr;
                gap: 0px 20px;
                grid-auto-flow: row;
                grid-template-areas:
                "lom-zweispaltig-spalte-1 lom-zweispaltig-spalte-2";
                margin-bottom: 30px;
            }

            .lom-zweispaltig-spalte-1 {
                grid-area: lom-zweispaltig-spalte-1;
            }

            .lom-zweispaltig-spalte-2 {
                grid-area: lom-zweispaltig-spalte-2;
            }

            .lom-vierspaltig {
                display: grid;
                grid-template-columns: 1fr 1fr 1fr 1fr;
                grid-template-rows: 1fr;
                gap: 0px 20px;
                grid-auto-flow: row;
                grid-template-areas:
                "lom-vierspaltig-spalte-1 lom-vierspaltig-spalte-2 lom-vierspaltig-spalte-3 lom-vierspaltig-spalte-4";
            }

            .lom-vierspaltig-spalte-1 {
                grid-area: lom-vierspaltig-spalte-1;
                margin-bottom: 20px;
            }

            .lom-vierspaltig-spalte-2 {
                grid-area: lom-vierspaltig-spalte-2;
                margin-bottom: 20px;
            }

            .lom-vierspaltig-spalte-3 {
                grid-area: lom-vierspaltig-spalte-3;
                margin-bottom: 20px;
            }

            .lom-vierspaltig-spalte-4 {
                grid-area: lom-vierspaltig-spalte-4;
                margin-bottom: 20px;
            }


            @media only screen and (max-width: 640px) {
                .lom-zweispaltig {
                display: block;
                grid-template-columns: 1fr 1fr;
                grid-template-rows: 1fr;
                gap: 10px 0px;
                grid-auto-flow: row;
                grid-template-areas:
                    "lom-zweispaltig-spalte-1 lom-zweispaltig-spalte-2";
                }

                .lom-zweispaltig-spalte-1 {
                grid-area: lom-zweispaltig-spalte-1;
                }

                .lom-zweispaltig-spalte-2 {
                grid-area: lom-zweispaltig-spalte-2;
                }

                .lom-vierspaltig {
                display: block;
                grid-template-columns: 1fr 1fr 1fr 1fr;
                grid-template-rows: 1fr;
                gap: 10px 0px;
                grid-auto-flow: row;
                grid-template-areas:
                    "lom-vierspaltig-spalte-1 lom-vierspaltig-spalte-2 lom-vierspaltig-spalte-3 lom-vierspaltig-spalte-4";
                }

                .lom-vierspaltig-spalte-1 {
                grid-area: lom-vierspaltig-spalte-1;
                }

                .lom-vierspaltig-spalte-2 {
                grid-area: lom-vierspaltig-spalte-2;
                }

                .lom-vierspaltig-spalte-3 {
                grid-area: lom-vierspaltig-spalte-3;
                }

                .lom-vierspaltig-spalte-4 {
                grid-area: lom-vierspaltig-spalte-4;
                }

                .lom-button-ausrichtung {
                vertical-align: middle;
                text-align: left;
                }
            }
            
            @media (max-width: 1240px) {
                .lom-vierspaltig {
                grid-template-columns: 1fr 1fr;
                grid-template-areas:
                    "lom-vierspaltig-spalte-1 lom-vierspaltig-spalte-2"
                    "lom-vierspaltig-spalte-3 lom-vierspaltig-spalte-4";
                }
            }
            `;
        return (
            <div className="uk-container">
                <Helmet>
                    <script type="application/ld+json">
                        {`{
                            "@context": "https://schema.org",
                            "@type": "FAQPage",
                            "mainEntity": [{
                                "@type": "Question",
                                "name": "Welche Vorteile bietet Original-Audi-Zubehör gegenüber Fremdherstellern?",
                                "acceptedAnswer": {
                                    "@type": "Answer",
                                    "text": "Original-Audi-Zubehör ist speziell auf Ihr Modell abgestimmt und bietet daher die gewünschte Passform und höchste Qualität. Das führt zu einer hervorragenden Performance und Langlebigkeit."
                                }
                            }, {
                                "@type": "Question",
                                "name": "Kann ich das Audi-Zubehör selbst montieren?",
                                "acceptedAnswer": {
                                    "@type": "Answer",
                                    "text": "Viele Zubehörteile sind für eine einfache Selbstmontage konzipiert. Bei komplexeren Einbauten stehen Ihnen unsere Experten gern zur Verfügung."
                                }
                            }, {
                                "@type": "Question",
                                "name": "Ist das Zubehör mit älteren Audi-Modellen kompatibel?",
                                "acceptedAnswer": {
                                    "@type": "Answer",
                                    "text": "Wir bieten Zubehör für eine breite Palette von Modellen an. Details zur Kompatibilität finden Sie in der Produktbeschreibung oder bei einer persönlichen Beratung durch unser Fachteam."
                                }
                            }]
                        }`}
                    </script>
                    <style type="text/css">{styleContent}</style>
                </Helmet>
                <img
                    style={{ marginTop: "50px" }}
                    src="https://techno-images.s3.eu-central-1.amazonaws.com/technoImages/own-articles/landingpage-audi-zubehoer-header.jpg"
                    width="1199"
                    height="300"
                    alt="Audi"
                />
                <div className="lom-box-h1">
                    <h1 style={{ color: "#fff" }}>Audi-Zubehör</h1>
                </div>

                <p>Verleihen Sie Ihrem Audi mehr Komfort, Stil und Funktionalit&auml;t &ndash; mit&nbsp;unserem <strong>gro&szlig;en Sortiment an Original-Audi-Zubeh&ouml;r</strong>. Ob praktische Transportl&ouml;sungen, edle Designakzente oder passendem Merchandise: Entdecken Sie die Vielfalt hochwertiger Audi-Produkte im Shop von Gottfried Schultz.</p>


                <h2>Entdecken Sie unsere Audi-Kategorien</h2>

                {/* CATEGORY BLOCKS */}
                <div className="lom-vierspaltig">
                    {[
                        {
                            title: "Duftspender & -geckos",
                            img: "audi-duftspender.webp",
                            href: "/pflegeReinigung/filters/audi_duftspender",
                        },
                        {
                            title: "Schriftzüge",
                            img: "audi-schriftzuege.webp",
                            href: "/folienAufkleber/filters/audi",
                        },
                        {
                            title: "Scheibenwischer",
                            img: "audi-scheibenwischer.webp",
                            href: "/aussenZubehoer/filters/audi_scheibenwischer",
                        },
                        {
                            title: "Kofferraummatten",
                            img: "audi-kofferraummatten.webp",
                            href: "/kofferraum/filters/audi_gepaeckraumschale",
                        },
                    ].map((item, i) => (
                        <div className={`lom-vierspaltig-spalte-${i + 1}`} key={i}>
                            <div className="lom-box-kategorie">
                                <h3>
                                    Audi <br />
                                    {item.title}
                                </h3>
                                <img
                                    src={`https://techno-images.s3.eu-central-1.amazonaws.com/technoImages/own-articles/${item.img}`}
                                    style={{ maxWidth: "150px" }}
                                    alt={`Audi ${item.title}`}
                                />
                                <a className="lom-button-kategorie" href={item.href}>
                                    Zur Kategorie
                                </a>
                            </div>
                        </div>
                    ))}
                </div>

                <div className="lom-vierspaltig">
                    {[
                        {
                            title: "Auspuffblenden",
                            img: "audi-auspuffblenden.webp",
                            href: "/ersatzteile/filters/audi_endrohrblende.endrohrblenden",
                        },
                        {
                            title: "Anhängerkupplungen",
                            img: "audi-anhaengerkupplungen.webp",
                            href: "/anhaengerkupplung/filters/audi",
                        },
                        {
                            title: "Fußmatten",
                            img: "audi-fussmatten.webp",
                            href: "/fussmatten/filters/audi",
                        },
                        {
                            title: "Dachträger",
                            img: "audi-dachtr%C3%A4ger.webp",
                            href: "/dachtraeger/filters/audi",
                        },
                    ].map((item, i) => (
                        <div className={`lom-vierspaltig-spalte-${i + 1}`} key={i}>
                            <div className="lom-box-kategorie">
                                <h3>
                                    Audi <br />
                                    {item.title}
                                </h3>
                                <img
                                    src={`https://techno-images.s3.eu-central-1.amazonaws.com/technoImages/own-articles/${item.img}`}
                                    style={{ maxWidth: "150px" }}
                                    alt={`Audi ${item.title}`}
                                />
                                <a className="lom-button-kategorie" href={item.href}>
                                    Zur Kategorie
                                </a>
                            </div>
                        </div>
                    ))}
                </div>

                <div className="lom-vierspaltig">
                    {[
                        {
                            title: "Schneeketten",
                            img: "audi-schneeketten.webp",
                            href: "/schneeketten/filters/audi",
                        },
                        {
                            title: "Winterkompletträder",
                            img: "audi-winterkomplettraeder.webp",
                            href: "/winterkomplettrad/filters/audi",
                        },
                        {
                            title: "Pedalkappen",
                            img: "audi-pedalkappen.webp",
                            href: "/ersatzteile/filters/audi_pedalkappen",
                        },
                        {
                            title: "Modellautos",
                            img: "audi-modellautos.webp",
                            href: "/modellautos/filters/audi.minimax",
                        },
                    ].map((item, i) => (
                        <div className={`lom-vierspaltig-spalte-${i + 1}`} key={i}>
                            <div className="lom-box-kategorie">
                                <h3>
                                    Audi <br />
                                    {item.title}
                                </h3>
                                <img
                                    src={`https://techno-images.s3.eu-central-1.amazonaws.com/technoImages/own-articles/${item.img}`}
                                    style={{ maxWidth: "150px" }}
                                    alt={`Audi ${item.title}`}
                                />
                                <a className="lom-button-kategorie" href={item.href}>
                                    Zur Kategorie
                                </a>
                            </div>
                        </div>
                    ))}
                </div>

                <div className="lom-vierspaltig">
                    {[
                        {
                            title: "Uhren",
                            img: "audi-uhr.webp",
                            href: "/accessoires/filters/audi_uhren",
                        },
                        {
                            title: "Kleidung",
                            img: "audi-kleidung.webp",
                            href: "/bekleidung/filters/audi",
                        },
                        {
                            title: "Schlüsselanhänger",
                            img: "audi-schluesselanhaenger.webp",
                            href: "/accessoires/filters/audi_schluesselanhaenger",
                        },
                        {
                            title: "Schlüsselblenden",
                            img: "audi-schluesselblende.webp",
                            href: "/accessoires/filters/audi_schluesselblende",
                        },
                    ].map((item, i) => (
                        <div className={`lom-vierspaltig-spalte-${i + 1}`} key={i}>
                            <div className="lom-box-kategorie">
                                <h3>
                                    Audi <br />
                                    {item.title}
                                </h3>
                                <img
                                    src={`https://techno-images.s3.eu-central-1.amazonaws.com/technoImages/own-articles/${item.img}`}
                                    style={{ maxWidth: "150px" }}
                                    alt={`Audi ${item.title}`}
                                />
                                <a className="lom-button-kategorie" href={item.href}>
                                    Zur Kategorie
                                </a>
                            </div>
                        </div>
                    ))}
                </div>

                <hr style={{ border: "5px solid #fff" }} />

                <h2>Hochwertiges Original-Zubeh&ouml;r f&uuml;r Ihr Audi-Modell</h2>
                <p style={{ marginBottom: 40 }}>Jedes Audi-Modell hat seinen eigenen <strong>Charme und Charakter</strong>. Damit Sie
                    das Optimum aus Ihrem Fahrzeug herausholen, bieten wir ein speziell abgestimmtes Sortiment an Audi-Zubeh&ouml;r
                    f&uuml;r s&auml;mtliche Modelle: <strong>A1, A3, A4, A5, A7, Q3, Q4, SQ2</strong> und weitere an. Ob es sich um eine
                    sch&uuml;tzende Audi-Kofferraummatte oder elegante Audi-Schneeketten f&uuml;r winterliche Fahrten handelt &ndash;
                    unser Zubeh&ouml;r verbessert Funktionalit&auml;t und &Auml;sthetik gleicherma&szlig;en.</p>


                <div class="lom-zweispaltig">
                    <div class="lom-zweispaltig-spalte-1">
                        <img style={{ marginBottom: 10 }}
                            src="https://techno-images.s3.eu-central-1.amazonaws.com/technoImages/own-articles/landingpage-audi-zubehoer-bild1.jpg"
                            alt="Audi mit Audi-Fahrradträger" />
                    </div>
                    <div class="lom-zweispaltig-spalte-2">
                        <h2>Komfort und Schutz f&uuml;r den Alltag &ndash; ma&szlig;geschneidertes Audi-Zubeh&ouml;r</h2>
                        <p>Im Alltag ist der Schutz Ihres Fahrzeugs ebenso wichtig wie sein Erscheinungsbild. Unsere
                            <strong> Audi-Scheibenwischer</strong> sorgen jederzeit f&uuml;r klare Sicht, w&auml;hrend die
                            <strong> Audi-Kofferraummatte </strong>vor Schmutz und Abnutzung sch&uuml;tzt. Und f&uuml;r die kalte Jahreszeit
                            bieten die <strong>Audi-Winterkomplettr&auml;der</strong> und <strong>Audi-Schneeketten</strong> den n&ouml;tigen
                            Halt auf verschneiten Stra&szlig;en. Mit diesem Zubeh&ouml;r bleibt Ihr Audi sicher und in bester Form.
                        </p>
                        <h2>Individualisierung mit Stil f&uuml;r Ihr Audi-Erlebnis</h2>
                        <p>Gestalten Sie Ihren Audi so einzigartig wie sich selbst. Unser Angebot umfasst stilvolle
                            <strong> Audi-Schl&uuml;sselblenden</strong> und <strong>Audi-Schl&uuml;sselanh&auml;nger</strong>, die feine
                            Akzente setzen. F&uuml;r Enthusiasten, die au&szlig;erhalb des Fahrzeugs das volle Marken-Erlebnis suchen, haben
                            wir ebenfalls etwas im Angebot: Unsere <strong>Audi-Kleidung</strong> und <strong>die eleganten
                                Audi-Uhren</strong> bieten Ihnen die M&ouml;glichkeit, die vier Ringe stilvoll im Alltag aufzugreifen.
                        </p>

                    </div>
                </div>

                <div class="lom-box-grau">
                    <h3>Must-haves f&uuml;r jeden Audi-Besitzer:</h3>
                    <ul>
                        <li><strong>Audi-Dachtr&auml;ger</strong>: Ideal f&uuml;r Abenteuerlustige, die auf ihren Reisen mehr
                            Gep&auml;ckraum ben&ouml;tigen.</li>
                        <li><strong>Audi-Anh&auml;ngerkupplung</strong>: Sicherer Transport von Anh&auml;ngern oder Fahrradtr&auml;gern.
                        </li>
                        <li><strong>Audi-Innenausstattung</strong>: Erh&ouml;ht den Innenkomfort und bietet Beifahrern ein luxuri&ouml;ses
                            Fahrgef&uuml;hl.</li>
                        <li><strong>Audi-Duftspender</strong> und <strong>Audi-Duftgecko</strong>: Bringen eine frische Note in Ihr Auto, um
                            die Fahrt noch angenehmer zu gestalten.</li>
                    </ul>
                </div>

                <div class="lom-zweispaltig">
                    <div class="lom-zweispaltig-spalte-1">
                        <img style={{ marginBottom: 10 }}
                            src="https://techno-images.s3.eu-central-1.amazonaws.com/technoImages/own-articles/landingpage-audi-zubehoer-bild2.jpg"
                            alt="Audi Innenraum mit Duftspender" />
                    </div>
                    <div class="lom-zweispaltig-spalte-2">
                        <h2>Das Audi-Zubeh&ouml;r-Erlebnis</h2>
                        <p>Wir pr&auml;sentieren wir Ihnen ein riesiges Sortiment an Audi-Zubeh&ouml;r und unterst&uuml;tzen Sie gern mit
                            <strong> einer umfassenden Beratung</strong>. Unser erkl&auml;rtes Ziel ist es, Ihnen das beste Zubeh&ouml;r
                            f&uuml;r Ihre spezifischen Anforderungen zu empfehlen. Bei uns finden Sie <strong>alle Audi-Accessoires an einem
                                Ort</strong>. Von praktischen L&ouml;sungen bis hin zu luxuri&ouml;sen Erg&auml;nzungen &ndash; bei uns
                            entdecken Sie, was Ihr Audi-Herz begehrt.
                        </p>
                        <h2>Audi-Zubeh&ouml;r als ausgezeichnetes Geschenk</h2>
                        <p>Suchen Sie nach einem Geschenk f&uuml;r einen Audi-Liebhaber in Ihrem Umfeld? Unsere Kollektion umfasst
                            <strong> Audi-Modellautos</strong>, die sowohl bei Sammlern als auch bei Kindern beliebt sind. Sie binden die
                            Leidenschaft f&uuml;r Audi in einem kleinen, aber liebevoll gestalteten Format, das jedem Beschenkten Freude
                            bereitet.
                        </p>

                    </div>
                </div>

                <h2>Die Perfektion liegt im Detail</h2>
                <p>Bei dem Audi-Zubeh&ouml;r ist es das Detail, das den Unterschied macht. Jede Komponente, von der
                    <strong> Audi-Fu&szlig;matte</strong> bis zum <strong> Audi-Schriftzug</strong>, ist durchdacht gestaltet und steht
                    f&uuml;r die Qualit&auml;t und den innovativen Geist, die Audi auszeichnen. Egal, ob Sie auf der Suche nach mehr
                    Komfort, zus&auml;tzlicher Sicherheit oder einem Hauch von Luxus sind. Bei uns sind Sie an der richtigen Adresse, um
                    Ihr Fahrzeug zu optimieren.
                </p>
                <p>Erleben Sie das volle Potenzial Ihres Fahrzeugs mit unserem umfangreichen Audi-Zubeh&ouml;r. Ganz gleich, welchen
                    Aspekt Ihres Fahrzeugs Sie verbessern m&ouml;chten &ndash; bei uns finden Sie die L&ouml;sung. Lassen Sie sich von der
                    <strong> Vielfalt und Qualit&auml;t</strong> inspirieren und machen Sie Ihren Audi zu einem individuellen
                    Meisterst&uuml;ck.
                </p>

                <h2>FAQ</h2>
                <details class="lom-faq-details">
                    <summary class="lom-faq-summary"><strong>Welche Vorteile bietet Original-Audi-Zubeh&ouml;r gegen&uuml;ber
                        Fremdherstellern?</strong></summary>
                    <div class="lom-faq-antwort">
                        <p>Original-Audi-Zubeh&ouml;r ist speziell auf Ihr Modell abgestimmt und bietet daher die gew&uuml;nschte Passform
                            und h&ouml;chste Qualit&auml;t. Das f&uuml;hrt zu einer hervorragenden Performance und Langlebigkeit.</p>
                    </div>
                </details>

                <details class="lom-faq-details">
                    <summary class="lom-faq-summary"><strong>Kann ich das Audi-Zubeh&ouml;r selbst montieren?</strong></summary>
                    <div class="lom-faq-antwort">
                        <p>Viele Zubeh&ouml;rteile sind f&uuml;r eine einfache Selbstmontage konzipiert. Bei komplexeren Einbauten stehen
                            Ihnen unsere Experten gern zur Verf&uuml;gung.</p>
                    </div>
                </details>

                <details class="lom-faq-details">
                    <summary class="lom-faq-summary"><strong>Ist das Zubeh&ouml;r mit &auml;lteren Audi-Modellen kompatibel?</strong>
                    </summary>
                    <div class="lom-faq-antwort">
                        <p>Wir bieten Zubeh&ouml;r f&uuml;r eine breite Palette von Modellen an. Details zur Kompatibilit&auml;t finden Sie
                            in der Produktbeschreibung oder bei einer pers&ouml;nlichen Beratung durch unser Fachteam.</p>
                    </div>
                </details>
            </div>
        );
    }
}

export default GottfriedLandingPage;
